import {
    HURTON_CATEGORIES_FETCH_FAILURE,
    HURTON_CATEGORIES_FETCH_SUCCESS,
    HURTON_CATEGORIES_FETCHING,
} from '../actions/types'

const INITIAL_STATE = {
    items: {},
    fetching: false,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HURTON_CATEGORIES_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case HURTON_CATEGORIES_FETCH_SUCCESS:
            return {
                ...state,
                items: prepareCategories(action.payload),
                fetching: false,
            }

        case HURTON_CATEGORIES_FETCH_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

const prepareCategories = categories => {
    let result = {}

    categories.forEach(item => {
        result[item.id] = item
    })

    return result
}

export default reducer
